import React from 'react'

// Splits an i18n template string like "%{amount} raised by %{donors}"
// and substitutes the React node from `values` for each named
// placeholder. Returns an array (text segments + JSX nodes) suitable
// for direct JSX rendering.
//
// Placeholder positions are resolved by name rather than by order,
// so a translation can move %{amount} after %{donors} (or wherever
// natural for the language) without scrambling which JSX node
// lands where — the substitution still finds the right one.
const renderI18nTemplate = (template, values) =>
  (template || '').split(/%\{(\w+)\}/g).map((part, i) =>
    i % 2 === 0
      ? part
      : <React.Fragment key={i}>{values[part]}</React.Fragment>
  )

export default renderI18nTemplate
